<template>
  <b-modal
    id="editModal"
    ref="modal"
    :title="title"
    @hide="onHide"
    @cancel="onCancel"
    :centered="true"
    :visible="open"
    :ok-title="okTitle"
    :cancel-title="$t('general.cancel')"
    :size="size"
    @ok="saveModal"
    :ok-disabled="disabled"
    :static="true"
    scrollable
    :hide-footer="hideFooterVal"
  >
    <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>
    <component
      ref="modalForm"
      :sendRequest="sendRequest"
      v-bind:is="renderModalForm"
      :save="saveAct"
      :data="modalProps"
      :changeVal="changeDisabled"
      :saveState="saveState"
      :modalName="modalName"
      :modalEvent="modalEvent"
      :formName="formSchema"
      :onComplete="onComplete"
      :forms="forms[formSchema]"
      :input="input"
      :style="{height: height}"

    >
    </component>
  </b-modal>
</template>

<script>
import i18n from "@/plugins/i18n";
import SetState from "./SetState";
import Delete from "./Delete";
import AddImage from './AddImageSupport'
import Report from './Report'
import Detail from './Detail'
import UnTrack from './UnTrack'
import Form from '@/components/Form'
import Forms from '../forms'
import { sendRequestList, sendRequest} from '@/assets/js/custom.js'

export default {
  name: "StockModal",
  data: function () {
    return {
      title: "",
      okTitle: i18n.t("general.save"),
      disabled: false,
      saveAct: false,
      input: [],
      saveAct: false,
      size: 'lg',
      hideFooterVal: false,
      forms: Forms,
      formSchema: '',
      height: 'auto'
    };
  },
  props: {
    open: Boolean,
    modalEvent: Function,
    form: String,
    modalName: String,
    modalProps: Object,
    onComplete: Function,
  },
  components: {
    Delete,
    SetState,
    AddImage,
    Report, 
    Form, 
    Detail,
    UnTrack
  },
  computed: {
    loading(){
        return this.$store.getters.getStockLoading
    },
    //Açılacak Modalı belirleme işlemleri
    renderModalForm: function () {
      this.hideFooterVal = false
      this.disabled = false
      this.size = 'lg'
      this.title = i18n.t('general.'+this.modalName)
      this.okTitle = i18n.t('general.'+this.modalName)
      this.formSchema = this.form;
      this.height = 'auto'
      if(this.modalName === "delete") {
        return "Delete"
      }
      if (this.modalName === "SetState") {
        this.title = "Durum Değiştir";
        this.okTitle = "Değiştir";
        return "SetState";
      } else if (this.modalName === "detail") {
        this.title = 'Hareket Detayı'
        this.okTitle = 'Rapor Al';
        return "Detail";
      }else if (this.modalName === "movement") {
        this.title = "Yeni Arıza Destek Hareketi"
        this.okTitle = "Ekle"
       this.formSchema = 'FaultMovement'
      }else if (this.modalName === "close") {
        this.title = "Desteği Sonlandır"
        this.okTitle = "Desteği Sonlandır"
        this.formSchema = 'FaultClose'
      }else if (this.modalName === "image") {
        this.title = "Resim Ekle"
        this.okTitle = "Ekle"
        this.formSchema = 'FaultImage'
        this.height = '700px'
      }  else if (this.modalName === "report") {
        this.title = "Rapor Al"
        this.okTitle = "Raporu Al"
        return "Report";
      } else if (this.modalName === "stock") {
        this.title = "Üretilen Barkodları Stoğa Al"
        this.okTitle = "Stok Hareketi Ekle"
       this.formSchema = 'Movement'
       this.size='xl'
      }else if (this.modalName === "untrack") {
        this.title = "Takip Dışı Cihaza İşlem"
        this.okTitle = "İşlemi Yap"
        this.size = 'xl'
        this.$store.dispatch(('untrack_info_get'), {serial_number: this.modalProps.serial_number})
        return "UnTrack";
      }
      sendRequestList(this.forms[this.formSchema], this)
      return 'Form'
    },
  },
  watch: {
    saveAct() {
      return false;
    },
  },
  methods: {
    sendRequest: async function(){ 
        await sendRequest(this)
        if(this.$store.getters.getStockStatus.status == "Success"){
            await this.$store.dispatch((this.form+'_get').toLowerCase(), {parent_id: parseInt(this.$route.params.id)})
            this.modalEvent(false)
        }
        if(this.form == 'faultSupports' && this.$route.params.id){
          await this.$store.dispatch('fetchFaultSupport', this.$route.params.id)
        }
        this.saveState(false)
    },
    onHide: function () {
      if (!this.saveAct) this.modalEvent(false);
    },
    onCancel: function () {
      this.saveState(false);
      if (!this.saveAct) this.modalEvent(false);
    },
    saveState: function (val) {
      this.saveAct = val;
    },
    // Modal tamamlandığı zaman olacak event
    saveModal: async function (bvModalEvt) {
      bvModalEvt.preventDefault();
      // Modalın içerisindeki watchı tetikler
      this.saveState(true);
    },
    changeData(val, name) {
      this.modalProps[name] = val;
    },
    changeDisabled(val) {
      if (val == this.modalProps.name) this.disabled = false;
      else this.disabled = true 
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/ERP/Stock/modals/index.vue